/** Inline SVGs for Plotly modebar (image href icons are unreliable in dynamic SVG). */



export const MODEBAR_ICON_EXPAND_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none"><path d="M10 2H14V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M6 14H2V10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M14.0007 2L9.33398 6.66667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/><path d="M2 14.0007L6.66667 9.33398" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>`;



export const MODEBAR_ICON_CSV_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M4.3125 16.875C4.3125 18.0122 5.06906 18.9375 6 18.9375C6.20639 18.9335 6.40981 18.8875 6.59789 18.8024C6.78597 18.7173 6.95478 18.5949 7.09406 18.4425C7.19833 18.3397 7.33858 18.2816 7.48502 18.2805C7.63145 18.2795 7.77252 18.3356 7.87825 18.4369C7.98397 18.5382 8.04601 18.6768 8.05118 18.8231C8.05635 18.9695 8.00424 19.1121 7.90594 19.2206C7.66233 19.4833 7.36761 19.6935 7.03987 19.8383C6.71213 19.9831 6.35827 20.0594 6 20.0625C4.44937 20.0625 3.1875 18.6328 3.1875 16.875C3.1875 15.1172 4.44937 13.6875 6 13.6875C6.35841 13.6909 6.71235 13.7675 7.0401 13.9126C7.36785 14.0576 7.66249 14.2682 7.90594 14.5312C8.00424 14.6398 8.05635 14.7824 8.05118 14.9287C8.04601 15.0751 7.98397 15.2136 7.87825 15.315C7.77252 15.4163 7.63145 15.4724 7.48502 15.4714C7.33858 15.4703 7.19833 15.4122 7.09406 15.3094C6.95498 15.1566 6.78625 15.0338 6.59816 14.9484C6.41006 14.8629 6.20654 14.8167 6 14.8125C5.06906 14.8125 4.3125 15.7369 4.3125 16.875ZM11.9109 16.2403C10.8928 15.9469 10.6538 15.8006 10.6922 15.4988C10.6976 15.404 10.7247 15.3117 10.7716 15.2291C10.8184 15.1465 10.8836 15.0758 10.9622 15.0225C11.4872 14.6672 12.6178 14.8519 12.9731 14.9437C13.116 14.9779 13.2666 14.9549 13.3928 14.8794C13.5189 14.804 13.6104 14.6823 13.6479 14.5402C13.6854 14.3981 13.6658 14.247 13.5933 14.1192C13.5208 13.9914 13.4012 13.897 13.26 13.8563C13.0725 13.8066 11.3756 13.3875 10.3341 14.0887C10.1226 14.232 9.94512 14.4199 9.81423 14.6392C9.68334 14.8586 9.60221 15.104 9.57656 15.3581C9.40781 16.6884 10.7259 17.0691 11.5988 17.3212C12.735 17.6494 12.9844 17.8209 12.93 18.2363C12.9252 18.3358 12.8973 18.4329 12.8484 18.5197C12.7996 18.6066 12.7313 18.681 12.6487 18.7369C12.1228 19.0866 11.01 18.8906 10.6622 18.795C10.5229 18.7662 10.3778 18.7913 10.2562 18.8651C10.1346 18.939 10.0456 19.0562 10.0069 19.1931C9.96832 19.33 9.983 19.4765 10.0481 19.603C10.1131 19.7296 10.2237 19.8267 10.3575 19.875C10.8066 19.9947 11.269 20.0577 11.7338 20.0625C12.2484 20.0625 12.8156 19.9734 13.2675 19.6744C13.4848 19.5294 13.6674 19.3381 13.802 19.1143C13.9367 18.8905 14.0202 18.6396 14.0466 18.3797C14.235 16.9116 12.8363 16.5075 11.9109 16.2394V16.2403ZM19.6922 13.7203C19.6226 13.6954 19.5489 13.6845 19.4751 13.6882C19.4013 13.6918 19.3289 13.7099 19.2622 13.7415C19.1954 13.7731 19.1355 13.8176 19.0859 13.8723C19.0363 13.9271 18.998 13.9911 18.9731 14.0606L17.625 17.8266L16.2797 14.0625C16.2577 13.9897 16.2211 13.9221 16.1722 13.8638C16.1233 13.8056 16.0631 13.7578 15.9952 13.7235C15.9274 13.6891 15.8532 13.6689 15.7773 13.6641C15.7014 13.6592 15.6253 13.6698 15.5536 13.6951C15.4819 13.7205 15.4161 13.7602 15.3601 13.8117C15.3042 13.8633 15.2593 13.9256 15.2281 13.995C15.197 14.0644 15.1802 14.1394 15.1789 14.2155C15.1775 14.2915 15.1916 14.367 15.2203 14.4375L17.0953 19.6875C17.1344 19.7967 17.2062 19.8912 17.301 19.958C17.3958 20.0248 17.509 20.0607 17.625 20.0607C17.741 20.0607 17.8542 20.0248 17.949 19.958C18.0438 19.8912 18.1156 19.7967 18.1547 19.6875L20.0297 14.4375C20.0795 14.2969 20.0715 14.1422 20.0073 14.0076C19.9431 13.8729 19.8281 13.7692 19.6875 13.7194L19.6922 13.7203ZM20.0625 8.25V10.5C20.0625 10.6492 20.0032 10.7923 19.8977 10.8977C19.7923 11.0032 19.6492 11.0625 19.5 11.0625C19.3508 11.0625 19.2077 11.0032 19.1023 10.8977C18.9968 10.7923 18.9375 10.6492 18.9375 10.5V8.8125H14.25C14.1008 8.8125 13.9577 8.75324 13.8523 8.64775C13.7468 8.54226 13.6875 8.39918 13.6875 8.25V3.5625H5.25C5.20027 3.5625 5.15258 3.58225 5.11742 3.61742C5.08225 3.65258 5.0625 3.70027 5.0625 3.75V10.5C5.0625 10.6492 5.00324 10.7923 4.89775 10.8977C4.79226 11.0032 4.64918 11.0625 4.5 11.0625C4.35082 11.0625 4.20774 11.0032 4.10225 10.8977C3.99676 10.7923 3.9375 10.6492 3.9375 10.5V3.75C3.9375 3.4019 4.07578 3.06806 4.32192 2.82192C4.56806 2.57578 4.9019 2.4375 5.25 2.4375H14.25C14.3991 2.43763 14.5421 2.49698 14.6475 2.6025L19.8975 7.8525C20.003 7.95789 20.0624 8.10087 20.0625 8.25ZM18.1416 7.6875L14.8125 4.3575V7.6875H18.1416Z" fill="currentColor"/></svg>`;



export const MODEBAR_ICON_CAMERA_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 18" fill="none"><path d="M17.5 2.25H14.9012L13.6234 0.33375C13.555 0.231142 13.4623 0.147003 13.3535 0.0887865C13.2448 0.0305702 13.1233 0.0000740671 13 0H7C6.87665 0.0000740671 6.75522 0.0305702 6.64648 0.0887865C6.53773 0.147003 6.44502 0.231142 6.37656 0.33375L5.09781 2.25H2.5C1.90326 2.25 1.33097 2.48705 0.90901 2.90901C0.487053 3.33097 0.25 3.90326 0.25 4.5V15C0.25 15.5967 0.487053 16.169 0.90901 16.591C1.33097 17.0129 1.90326 17.25 2.5 17.25H17.5C18.0967 17.25 18.669 17.0129 19.091 16.591C19.5129 16.169 19.75 15.5967 19.75 15V4.5C19.75 3.90326 19.5129 3.33097 19.091 2.90901C18.669 2.48705 18.0967 2.25 17.5 2.25ZM18.25 15C18.25 15.1989 18.171 15.3897 18.0303 15.5303C17.8897 15.671 17.6989 15.75 17.5 15.75H2.5C2.30109 15.75 2.11032 15.671 1.96967 15.5303C1.82902 15.3897 1.75 15.1989 1.75 15V4.5C1.75 4.30109 1.82902 4.11032 1.96967 3.96967C2.11032 3.82902 2.30109 3.75 2.5 3.75H5.5C5.62351 3.75008 5.74512 3.71966 5.85405 3.66143C5.96297 3.60321 6.05583 3.51899 6.12438 3.41625L7.40125 1.5H12.5978L13.8756 3.41625C13.9442 3.51899 14.037 3.60321 14.146 3.66143C14.2549 3.71966 14.3765 3.75008 14.5 3.75H17.5C17.6989 3.75 17.8897 3.82902 18.0303 3.96967C18.171 4.11032 18.25 4.30109 18.25 4.5V15ZM10 5.25C9.18415 5.25 8.38663 5.49193 7.70827 5.94519C7.02992 6.39845 6.50121 7.04269 6.189 7.79643C5.87679 8.55018 5.7951 9.37958 5.95426 10.1797C6.11343 10.9799 6.50629 11.7149 7.08318 12.2918C7.66008 12.8687 8.39508 13.2616 9.19525 13.4207C9.99542 13.5799 10.8248 13.4982 11.5786 13.186C12.3323 12.8738 12.9766 12.3451 13.4298 11.6667C13.8831 10.9884 14.125 10.1908 14.125 9.375C14.1238 8.28136 13.6888 7.23287 12.9154 6.45955C12.1421 5.68624 11.0936 5.25124 10 5.25ZM10 12C9.48082 12 8.97331 11.846 8.54163 11.5576C8.10995 11.2692 7.7735 10.8592 7.57482 10.3795C7.37614 9.89989 7.32415 9.37209 7.42544 8.86289C7.52672 8.35369 7.77673 7.88596 8.14384 7.51884C8.51096 7.15173 8.97869 6.90172 9.48789 6.80044C9.99709 6.69915 10.5249 6.75114 11.0045 6.94982C11.4842 7.1485 11.8942 7.48495 12.1826 7.91663C12.471 8.34831 12.625 8.85582 12.625 9.375C12.625 10.0712 12.3484 10.7389 11.8562 11.2312C11.3639 11.7234 10.6962 12 10 12Z" fill="currentColor"/></svg>`;



/** Same removals as CceData / ChartsDataNew — keep zoomIn2d, zoomOut2d, autoScale2d. */

const MODEBAR_BUTTONS_TO_REMOVE = [

  "lasso2d",

  "select2d",

  "pan2d",

  "resetscale",

  "zoom",

  "toImage",

];

/** EDA composition-gradient cards — expand control only (matches legacy DEPTH_MODEBAR). */

const MODEBAR_BUTTONS_TO_REMOVE_EXPAND_ONLY = [

  ...MODEBAR_BUTTONS_TO_REMOVE,

  "zoom2d",

  "zoomIn2d",

  "zoomOut2d",

  "autoscale2d",

  "resetScale2d",

  "toggleSpikelines",

  "hoverClosestCartesian",

  "hoverCompareCartesian",

];



/**

 * QAQC / dashboard modebar: Expand (optional), CSV, PNG.

 * Uses modeBarButtonsToAdd (Plotly 2.x) — custom-only modeBarButtons does not render reliably.

 */

export function buildPlotlyModebarConfig(handlers = {}) {

  const { onExpand, onCsv, onPng, includeExpand = false, expandOnly = false } = handlers;

  const buttons = [];



  if (includeExpand && typeof onExpand === "function") {

    buttons.push({

      name: "Expand",

      icon: { svg: MODEBAR_ICON_EXPAND_SVG },

      click: onExpand,

    });

  }



  if (typeof onCsv === "function") {

    buttons.push({

      name: "Download CSV",

      icon: { svg: MODEBAR_ICON_CSV_SVG },

      click: onCsv,

    });

  }



  if (typeof onPng === "function") {

    buttons.push({

      name: "Download plot as a png",

      icon: { svg: MODEBAR_ICON_CAMERA_SVG },

      click: onPng,

    });

  }



  if (buttons.length === 0) {

    return {

      responsive: true,

      displaylogo: false,

      displayModeBar: false,

    };

  }



  return {

    responsive: true,

    displaylogo: false,

    displayModeBar: true,

    modeBarButtonsToRemove: expandOnly ? MODEBAR_BUTTONS_TO_REMOVE_EXPAND_ONLY : MODEBAR_BUTTONS_TO_REMOVE,

    modeBarButtonsToAdd: buttons,

  };

}



export function ensurePlotlyModebarVisible(chartEl) {

  if (!chartEl) {

    return;

  }

  const root = chartEl.classList?.contains("js-plotly-plot")

    ? chartEl

    : chartEl.querySelector?.(".js-plotly-plot");

  if (!root) {

    return;

  }

  const modebar = root.querySelector(".modebar");

  if (!modebar) {

    return;

  }

  modebar.style.display = "flex";

  modebar.style.visibility = "visible";

  modebar.style.opacity = "1";

  modebar.querySelectorAll(".modebar-group").forEach((group) => {

    const hasButtons = group.querySelector(".modebar-btn");

    if (hasButtons) {

      group.style.display = "flex";

    }

  });

}


